import React, { memo } from 'react'
import { LOADER } from 'constants/index'

const loaderLogoSrc = `${process.env.PUBLIC_URL || ''}/assets/v2-logo.png`

const defaultLoaderShellStyle = {
  minHeight: '100%',
  width: '100%',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '1.25rem',
  background: '#12151d',
  padding: '1rem'
}

const logoImgStyle = {
  display: 'block',
  width: 'min(280px, 70vw)',
  maxHeight: '6.5rem',
  height: 'auto',
  objectFit: 'contain'
}

const Loader = ({ component }) => {
  switch (component) {
    case LOADER.CONTENT:
      return (
        <div className='d-flex mt-2 mb-2 h-100 justify-content-center align-items-center'>
          <div className='spinner-border text-light mt-2 mb-2' role='status'>
            <span className='sr-only'>Loading...</span>
          </div>
        </div>
      )

    case LOADER.TABLE_CELL:
      return <span className='spinner-border spinner-border-sm text-light' role='status' aria-hidden='true' />

    case LOADER.BUTTON:
      return <span className='spinner-border spinner-border-sm text-light' role='status' aria-hidden='true' />

    default:
      return (
        <div style={defaultLoaderShellStyle}>
          <img
            src={loaderLogoSrc}
            alt='Gamma Poker'
            style={logoImgStyle}
            width={220}
            height={87}
          />
          <div className='d-flex justify-content-center spinner-border show-loader text-light' role='status' aria-label='Loading' />
        </div>
      )
  }
}

export default memo(Loader)
